









































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Agent } from "@/models/Agent";
import { container } from "@/services/registerServiceProvider";
import { IUserRoleService } from "@/services/IUserRoleService";
import Loader from "@/components/Loader.vue";

@Component({
  components: { Loader },
})
export default class AgentRank extends Vue {
  @Prop() public readonly agent!: Agent;
  @Prop() public readonly color?: string;

  public isAdmin: boolean = false;
  public isMentor: boolean = false;
  public isCurator: boolean = false;
  public isAgent: boolean = false;
  public roleText: string = "";

  private readonly userRoleService: IUserRoleService = container.resolve(
    "IUserRoleService",
  );

  created() {
    this.init();
  }

  init(): void {
    if (this.agent.user) {
      this.isAdmin = this.userRoleService.isUserAdmin(this.agent.user);
      this.isMentor = this.userRoleService.isUserMentor(this.agent.user);
      this.isCurator = this.userRoleService.isUserCurator(this.agent.user);
      this.isAgent = this.userRoleService.isUserAgent(this.agent.user);

      if (this.isAdmin) {
        this.roleText = "Администратор";
      } else if (this.isMentor) {
        this.roleText = "Наставник";
      } else if (this.isCurator) {
        this.roleText = "Куратор";
      } else if (this.isAgent) {
        this.roleText = "Агент";
      }
    }
  }

  get showRank() {
    return this.isAdmin || this.isMentor || this.isCurator || this.isAgent;
  }

  @Watch("agent.user")
  private userWatcher(): void {
    this.init();
  }
}
